import React, { useCallback, useEffect, useState } from 'react'
import { useApp } from '../../../helpers/appContext'
import HeaderTitle from '../../../components/HeaderTitle/HeaderTitle';
import Alert, { ALERT_TYPE } from '../../../components/Alert/Alert';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../../helpers/authContext';
import { RecordNavigator, Section, message, record, Print, general } from 'daymap-library';
import { useStudentPhotoUrl } from '../../../components/Containers/StudentPhoto';
import Student from '../../../components/Student/Student'

import styles from './Record.module.scss';

function Record() {
    const navigate = useNavigate();
    const [status, setStatus] = useState(null);
    const [actionResults, setActionResults] = useState(null);
    const [recordComplete, setRecordComplete] = useState(false);
    const { lmsFetch, settings } = useAuth();
    const { setKioskHeader, student, mode, AddState } = useApp();
    const { formId, rowIdParam } = useParams();
    const [printStrings, setPrintStrings] = useState([]);

    const loadRecord = async ({rowId}) => {
        const [getRecord] = lmsFetch(`/lms/api/forms/record?formId=${formId}&id=${student.ID}&editMode=${rowId ? 0 : 2}&rowId=${rowId}`);
        const [getKioskForms] = lmsFetch(`/lms/api/checkin/records?mode=${mode}`);
        const response = await getRecord();
        const formsResponse = await getKioskForms();

        if(response.error != null || formsResponse.error != null) {
            setActionResults([
                {
                    Success: false,
                    Message: response.error?.message || formsResponse.error?.message
                }
            ]);
            AddState("RecordLoadError", response.error?.message || formsResponse.error?.message)
            navigate("/kiosk/records");
        }

        const record = response.data.Record;
        const studentRecord = response.data;
        const kioskForm = formsResponse.data.find(f => f.FormID === studentRecord.Form.FormID);

        let title = (response.data.Form.Caption) ? response.data.Form.Caption : response.data.Form.Name;
        let status = record?.StatusCaption;
        if (record?.RowId === null || record.RowId === 0) {
            status = 'New Record';
        }
        if (record.StatusId < 1 && kioskForm?.CaptionNew)
            title = kioskForm?.CaptionNew;
        else if (kioskForm?.CaptionExisting)
            title = kioskForm?.CaptionExisting;

        setStatus(status);        
        setKioskHeader(<HeaderTitle text={title} />)

        const recordFields = studentRecord.Form.Items;
        studentRecord.Form.Items = recordFields.filter(rf => {
          // no permissions defined for field
          if (!rf.Permissions)
            return true;
  
          const fieldStatusPermissions = rf.Permissions.find(p => p.StatusId === studentRecord.Record.StatusId);
          
          // no permissions defined for status (not sure if this ever happens  but should assume the field is visible if so)
          if (!fieldStatusPermissions)
            return true;
          
          return (fieldStatusPermissions.Read & settings.CheckInUser.GroupMask) > 0 || (fieldStatusPermissions.Edit & settings.CheckInUser.GroupMask) > 0;
        });

        // need to check id this record has an absence code list field and if so whether it needs to be filtered
        const absenceField = studentRecord.Form.Items.find(f => (f.Flags & 16) > 0);
        if (absenceField) {
            const enabledCodes = kioskForm?.EnabledAbsenceCodes;
            if (absenceField.ListItems && enabledCodes && enabledCodes.length > 0) {
                absenceField.ListItems = absenceField.ListItems.filter(li => enabledCodes.indexOf(li.Value) > -1);
            }

            if (absenceField.ListItems.length === 1) {// select the only option by default if there is just 1
                const result = studentRecord.Record?.Results[absenceField.FieldID];
                console.log(result);
                if (result) {
                    result.ValueText = absenceField.ListItems[0].Value;
                    result.Value = absenceField.ListItems[0].Value;
                }
            }
        }

        return studentRecord;
    };

    const saveRecord = async ({ actionId, recordId, results, rowId, studentId }) => {
        const prints = [...printStrings];
        const postData = results.map(r => {
            let val = r.value;
            if (typeof val === 'boolean')
                val = `${val}`;
            return { FieldID: r.fieldId, Value: val };
        });

        const [saveRecord] = lmsFetch(`/lms/api/forms/record/save?formId=${recordId}&id=${studentId}&rowId=${rowId}&actionId=${actionId}&async=false`, postData);

        const response = await saveRecord();
        const actionResults = response.data.ActionResults;

        if ((!actionResults || actionResults.length === 0) && !response.data.Err) 
            setRecordComplete(true);
        else {
            const messageResults = [];
            actionResults.forEach(ar => {
                console.log(ar);
                if (ar.Script.indexOf('InfoForms.PrintReceiptUrl') >= 0) {
                    prints.push(ar.Script);
                }
                else if (ar.CheckType === 15 && ar.Script?.length > 0) // print check type and has the print params in the script prop
                    prints.push(ar.Script);
                else if (ar.Message?.length > 0)
                    messageResults.push(ar);
            });
            
            setActionResults(messageResults);
            setPrintStrings(prints);
            
            if (!messageResults.some(r => !r.Success))
                setRecordComplete(true);
        }
        
        return response;
    }

    return (
        <div className={styles.Wrapper}>
            <Section>
                <Student {...student} />
            </Section>
        <>
            {((actionResults && actionResults.length > 0) || recordComplete) && 
                <Section>
                    <RecordProcessed actionResults={actionResults} recordComplete={recordComplete} />
                </Section>
            }
            <Section>
                {status && <div className={styles.Status}>Status: <strong>{status}</strong></div>}
                {printStrings.map(ps => {
                    const params = getPrintParams(ps);
                    return <RecordReceiptPrint {...params} onPrintComplete={() => setRecordComplete(true)} />}
                )}
                <RecordNavigator 
                    autoSubmitSingleAction
                    studentId={student.ID} 
                    recordId={formId} 
                    rowId={rowIdParam} 
                    getRecordData={loadRecord} 
                    saveRecord={saveRecord} 
                    startMode={record.EDIT_MODE.Create} 
                    hideDefaultActions 
                    hideMenu
                    actionMenuPosition={record.ACTIONS_MENU_POSITION.Bottom} />
            </Section>
            </>
        </div>
    )
}

const RecordProcessed = ({ actionResults, recordComplete }) => {
    const { settings } = useAuth();
    const navigate = useNavigate();
    const [ secondsTilRedirect ] = general.useCountdown({ seconds: settings.KioskRedirectDelay, onZero: () => navigate('/kiosk') });

    if (!(settings.KioskRedirectDelay > 0)) {
        navigate('/kiosk');
        return "";
    }

    if (actionResults && actionResults.length > 0) {
        return (
            <>
                {actionResults.some(r => !r.Success) && (
                    <Alert type={ALERT_TYPE.Error} heading="Record Failed">
                        {actionResults
                            .filter(r => !r.Success)
                            .map((r, index) => (
                                <div key={index}>
                                    {r.Message}
                                </div>
                            ))}
                        <div>Returning to kiosk in {secondsTilRedirect} seconds.</div>
                    </Alert>
                )}
                
                {actionResults.some(r => r.Success) && (
                    <Alert type={ALERT_TYPE.Default}>
                        {actionResults
                            .filter(r => r.Success)
                            .map((r, index) => (
                                <div key={index}>
                                    {r.Message}
                                </div>
                            ))}
                    </Alert>
                )}
            </>
        );
    } else if (recordComplete) {
        return (
            <Alert type={ALERT_TYPE.Success} heading="Record Complete">
                Returning to kiosk in {secondsTilRedirect} seconds.
            </Alert>
        );
    }
}

const RecordReceiptPrint = ({ studentId, formId, rowId, templateId, copies, onPrintComplete }) => {
    const { lmsFetch } = useAuth();
    const [printHtml, setPrintHtml] = useState(null);
    const studentPhotoUrl = useStudentPhotoUrl(studentId);

    const getPrintHtml = useCallback(async () => {
        const [getHtml] = lmsFetch(`/lms/api/checkin/kiosk/receipt?formId=${formId}&studentId=${studentId}&rowId=${rowId}&templateId=${templateId}`, null, { returns: 'text' });
        const response = await getHtml();

        setPrintHtml(response.data);
    }, [formId, studentId, rowId, templateId, copies])

    useEffect(() => {
        getPrintHtml();
    }, []);

    if (!printHtml || !studentPhotoUrl)
        return null;

    const printStyle = `
        .photoThumb {
            display: block;
            width: 100px;
            height: 120px;
        }
        .NewPageAfter {
            page-break-after: always;
        }
    `;

    // update the student photo img tag to use the studentPhotoUrl
    let html = printHtml.replace(`student-id='${studentId}'`, `src="${studentPhotoUrl}"`);

    if (copies > 1) {
        let newHtml = '';
        for (let i =0; i < copies; i++) {
            newHtml += `<div class="NewPageAfter">${html}</div>`
        }
        html = newHtml;
    }

    return <Print onPrint={onPrintComplete} printBody={html} printStyle={printStyle} />
}

const getPrintParams = printString => {
    let options;
    if (printString.indexOf('?o=') > -1)
        options = printString.substring(printString.indexOf('?o=') + 3, printString.indexOf('")'));
    else
        options = printString;

    const [studentId, formId, rowId, templateId, copies = 1] = options.split(',');
    return { studentId, formId, rowId, templateId, copies };
}

export default Record